export default __webpack_public_path__ + "static/media/karusLogo.05b399dc.svg";